module.exports = __webpack_public_path__ + "Bild_2.7b979351de35cd1e113fcb60ffffc8b8.png";